import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectCheckedQuizzesIds } from 'store/quiz/quizzesSelectors';
import { selectCurrentUser } from 'store/currentUser/currentUserSelectors';
import UserRoles from 'types/UserRoles';
// Components
import { Button } from 'components/Buttons';
import CloneQuizzesDialog from 'dialogs/CloneQuizzes.dialog';

const QuizzesClone:FC = () => {
  const { t } = useTranslation();

  const currentUser = useAppSelector(selectCurrentUser);
  const checkedQuizzesIds = useAppSelector(selectCheckedQuizzesIds);

  const { open, toggle } = useToggle();

  const isDisabled = checkedQuizzesIds.length === 0;
  const isAdmin = currentUser?.groups.includes(UserRoles.Admin);

  if (!isAdmin) return null;
  return (
    <Fragment>
      <Button
        onClick={toggle}
        variant="contained"
        disabled={isDisabled}
      >
        {t('pages.quizzes.cloneButton')}
      </Button>
      {open ? (
        <CloneQuizzesDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default QuizzesClone;
